module.exports = __webpack_public_path__ + "img/bench-arrangement.7058cb5a.webp";